<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="false"
    width="500px"
    custom-class="modal-container"
  >
    <div slot="title" class="title">
      <span class="info">
        {{ title }}
      </span>
      <img
        alt="icon"
        class="icon"
        src="@/assets/images/login-dialog/img_64028_0_0.png"
        @click="visible = false"
      />
    </div>
    <div class="content">
      <slot />
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from "element-ui";

export default {
  name: "TipsDialog",
  props: {
    title: {
      type: String,
      default: "提示"
    }
  },
  components: {
    "el-dialog": Dialog
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    show() {
      // this.searchForm = initForm();
      this.visible = true;
    },
    hide() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss">
.form-input {
  .el-input__inner {
    color: #CA0A15;
    font-size: 14px;
    border: 1px solid #f0f0f0;
  }
}
</style>

<style lang="scss">
.modal-container {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.title {
  align-items: center;
  background-color: #fbe1c3;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  height: 50px;
  justify-content: space-between;
  overflow: hidden;
  padding-left: 21px;
  padding-right: 20px;
  position: relative;
  width: 500px;

  .info {
    color: #CA0A15;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 16px;
    text-decoration: none;
    font-weight: bold;
  }
  .icon {
    height: 10px;
    width: 10px;
    cursor: pointer;
  }
}

.content {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: 20px;
}
</style>
